function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Wrapper for the IrisGrid for use in a golden layout container
// Will probably need to handle window popping out from golden layout here.
import React, { PureComponent } from 'react';
import memoize from 'memoize-one';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { DEFAULT_DASHBOARD_ID, LayoutUtils } from '@deephaven/dashboard';
import { AdvancedSettings, IrisGrid, IrisGridModel, IrisGridCacheUtils, IrisGridUtils, isIrisGridTableModelTemplate } from '@deephaven/iris-grid';
import Log from '@deephaven/log';
import { getSettings, getUser } from '@deephaven/redux';
import { assertNotNull, PromiseUtils } from '@deephaven/utils';
import clamp from 'lodash.clamp';
import { IrisGridEvent } from "../events/index.js";
import { getInputFiltersForDashboard, getLinksForDashboard, getColumnSelectionValidatorForDashboard } from "../redux/index.js";
import WidgetPanel from "./WidgetPanel.js";
import "./IrisGridPanel.css";
import IrisGridPanelTooltip from "./IrisGridPanelTooltip.js";
import { isIrisGridPanelMetadata, isLegacyIrisGridPanelMetadata } from "./IrisGridPanelTypes.js";
import { emitFilterColumnsChanged, emitFilterTableChanged } from "../FilterEvents.js";
import { emitLinkPointSelected, emitLinkSourceDataSelected } from "../linker/LinkerEvent.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('IrisGridPanel');
var DEBOUNCE_PANEL_STATE_UPDATE = 500;

// Some of the properties in the loaded panel state may be omitted
// even though they can't be undefined in the dehydrated state.
// This can happen when loading the state saved before the properties were added.

function getTableNameFromMetadata(metadata) {
  if (metadata == null) {
    throw new Error('No metadata provided');
  }
  if (isIrisGridPanelMetadata(metadata)) {
    return metadata.name;
  }
  if (isLegacyIrisGridPanelMetadata(metadata)) {
    return metadata.table;
  }
  throw new Error("Unable to determine table name from metadata: ".concat(JSON.stringify(metadata)));
}
export class IrisGridPanel extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "irisGrid", void 0);
    _defineProperty(this, "pluginRef", void 0);
    _defineProperty(this, "modelPromise", void 0);
    _defineProperty(this, "irisGridState", void 0);
    _defineProperty(this, "gridState", void 0);
    _defineProperty(this, "pluginState", void 0);
    _defineProperty(this, "irisGridUtils", void 0);
    _defineProperty(this, "gridStateDehydrator", IrisGridCacheUtils.makeMemoizedGridStateDehydrator());
    _defineProperty(this, "irisGridStateDehydrator", IrisGridCacheUtils.makeMemoizedIrisGridStateDehydrator());
    _defineProperty(this, "getGridInputFilters", memoize((columns, inputFilters) => IrisGridUtils.getInputFiltersForColumns(columns,
    // They may have picked a column, but not actually entered a value yet. In that case, don't need to update.
    inputFilters.filter(_ref => {
      var value = _ref.value,
        excludePanelIds = _ref.excludePanelIds;
      var id = LayoutUtils.getIdFromPanel(this);
      return value != null && (excludePanelIds == null || id != null && !excludePanelIds.includes(id));
    }))));
    _defineProperty(this, "getAlwaysFetchColumns", memoize((dashboardLinks, pluginFetchColumns) => {
      var id = LayoutUtils.getIdFromPanel(this);
      // Always fetch columns which are the start/source of a link or columns specified by a plugin
      var columnSet = new Set(pluginFetchColumns);
      for (var i = 0; i < dashboardLinks.length; i += 1) {
        var start = dashboardLinks[i].start;
        if (start != null && start.panelId === id) {
          columnSet.add(start.columnName);
        }
      }
      return [...columnSet];
    }));
    _defineProperty(this, "getPluginContent", memoize((Plugin, model, pluginState) => {
      var _this$irisGrid$curren;
      if (!model || !isIrisGridTableModelTemplate(model) || Plugin == null || model.table == null) {
        return null;
      }

      // TODO #2093: Find a better way to handle deprecated panel prop
      var deprecatedProps = {
        panel: this
      };
      return /*#__PURE__*/_jsx("div", {
        className: "iris-grid-plugin",
        children: /*#__PURE__*/_jsx(Plugin, _objectSpread({
          ref: this.pluginRef,
          filter: this.handlePluginFilter,
          fetchColumns: this.handlePluginFetchColumns,
          model: model,
          table: model.table,
          tableName: this.getTableName(),
          selectedRanges: (_this$irisGrid$curren = this.irisGrid.current) === null || _this$irisGrid$curren === void 0 ? void 0 : _this$irisGrid$curren.state.selectedRanges,
          onStateChange: this.handlePluginStateChange,
          pluginState: pluginState
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, deprecatedProps))
      });
    }));
    _defineProperty(this, "getDehydratedIrisGridPanelState", memoize((model, isSelectingPartition, partitions, advancedSettings) => IrisGridUtils.dehydrateIrisGridPanelState(model, {
      isSelectingPartition,
      partitions,
      advancedSettings
    })));
    _defineProperty(this, "getCachedPanelState", memoize((irisGridPanelState, irisGridState, gridState, pluginState) => ({
      irisGridPanelState,
      irisGridState,
      gridState,
      pluginState
    })));
    _defineProperty(this, "getWidgetPanelDescriptor", memoize((metadata, description) => {
      var name = getTableNameFromMetadata(metadata);
      return _objectSpread(_objectSpread({
        type: 'Table',
        displayType: 'Table'
      }, metadata), {}, {
        name,
        description
      });
    }));
    _defineProperty(this, "savePanelState", debounce(() => {
      var irisGridState = this.irisGridState,
        gridState = this.gridState,
        pluginState = this.pluginState;
      assertNotNull(irisGridState);
      var onPanelStateUpdate = this.props.onPanelStateUpdate;
      var _this$state = this.state,
        model = _this$state.model,
        oldPanelState = _this$state.panelState,
        isSelectingPartition = _this$state.isSelectingPartition,
        partitions = _this$state.partitions,
        advancedSettings = _this$state.advancedSettings;
      assertNotNull(this.irisGridUtils);
      assertNotNull(model);
      assertNotNull(gridState);
      var panelState = this.getCachedPanelState(this.getDehydratedIrisGridPanelState(model, isSelectingPartition, partitions, advancedSettings), this.irisGridStateDehydrator(model, irisGridState), this.gridStateDehydrator(model, gridState), pluginState);
      if (panelState !== oldPanelState) {
        log.debug('Saving panel state', this, panelState);
        this.setState({
          panelState
        });
        onPanelStateUpdate === null || onPanelStateUpdate === void 0 || onPanelStateUpdate(panelState);
      }
    }, DEBOUNCE_PANEL_STATE_UPDATE));
    this.handleAdvancedSettingsChange = this.handleAdvancedSettingsChange.bind(this);
    this.handleColumnsChanged = this.handleColumnsChanged.bind(this);
    this.handleTableChanged = this.handleTableChanged.bind(this);
    this.handleColumnSelected = this.handleColumnSelected.bind(this);
    this.handleDataSelected = this.handleDataSelected.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleGridStateChange = this.handleGridStateChange.bind(this);
    this.handlePluginStateChange = this.handlePluginStateChange.bind(this);
    this.handleCreateChart = this.handleCreateChart.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleTabClicked = this.handleTabClicked.bind(this);
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.handleReconnect = this.handleReconnect.bind(this);
    this.handleLoadSuccess = this.handleLoadSuccess.bind(this);
    this.handleLoadError = this.handleLoadError.bind(this);
    this.isColumnSelectionValid = this.isColumnSelectionValid.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handlePluginFilter = this.handlePluginFilter.bind(this);
    this.handlePluginFetchColumns = this.handlePluginFetchColumns.bind(this);
    this.handleClearAllFilters = this.handleClearAllFilters.bind(this);
    this.handleErrorAction = this.handleErrorAction.bind(this);
    this.irisGrid = /*#__PURE__*/React.createRef();
    this.pluginRef = /*#__PURE__*/React.createRef();
    var _panelState = props.panelState;
    this.pluginState = null;
    this.irisGridUtils = null;
    this.state = {
      error: null,
      isDisconnected: false,
      isLoaded: false,
      isLoading: true,
      isModelReady: false,
      model: undefined,
      // State is hydrated from panel state when table is loaded
      advancedFilters: new Map(),
      aggregationSettings: {
        aggregations: [],
        showOnTop: false
      },
      advancedSettings: new Map(AdvancedSettings.DEFAULTS),
      customColumns: [],
      customColumnFormatMap: new Map(),
      columnAlignmentMap: new Map(),
      isFilterBarShown: false,
      quickFilters: new Map(),
      sorts: [],
      userColumnWidths: new Map(),
      userColumnWidthsByName: new Map(),
      userRowHeights: new Map(),
      reverse: false,
      movedColumns: [],
      movedRows: [],
      isSelectingPartition: false,
      partitions: [],
      rollupConfig: undefined,
      showSearchBar: false,
      searchValue: '',
      selectedSearchColumns: undefined,
      invertSearchColumns: true,
      Plugin: undefined,
      pluginFilters: [],
      pluginFetchColumns: [],
      modelQueue: [],
      pendingDataMap: new Map(),
      frozenColumns: undefined,
      // eslint-disable-next-line react/no-unused-state
      panelState: _panelState,
      // Dehydrated panel state that can load this panel
      irisGridStateOverrides: {},
      gridStateOverrides: {},
      isStuckToBottom: false,
      isStuckToRight: false,
      conditionalFormats: [],
      selectDistinctColumns: []
    };
  }
  componentDidMount() {
    this.initModel();
  }
  componentDidUpdate(prevProps, prevState) {
    var model = this.state.model;
    var makeModel = this.props.makeModel;
    if (model !== prevState.model) {
      if (prevState.model != null) {
        this.stopModelListening(prevState.model);
        prevState.model.close();
      }
      if (model != null) {
        this.startModelListening(model);
      }
    }
    if (makeModel !== prevProps.makeModel) {
      this.initModel();
    }
  }
  componentWillUnmount() {
    this.savePanelState.cancel();
    if (this.modelPromise != null) {
      this.modelPromise.cancel();
      this.modelPromise = undefined;
    }
    var model = this.state.model;
    if (model) {
      this.stopModelListening(model);
      model.close();
    }
  }
  getTableName() {
    var metadata = this.props.metadata;
    return getTableNameFromMetadata(metadata);
  }
  initModel() {
    this.setState({
      isModelReady: false,
      isLoading: true,
      error: null,
      isDisconnected: false
    });
    var _this$props = this.props,
      makeModel = _this$props.makeModel,
      transformModel = _this$props.transformModel;
    if (this.modelPromise != null) {
      this.modelPromise.cancel();
    }
    var modelPromise = transformModel != null ? Promise.resolve(makeModel()).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (model) {
        try {
          var transformedModel = yield transformModel(model);
          return transformedModel;
        } catch (e) {
          // The host owns the base model's lifecycle; if the transform
          // rejects it never returns a model for us to close, so close
          // the base model here to avoid leaking it.
          model.close();
          throw e;
        }
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()) : Promise.resolve(makeModel());
    this.modelPromise = PromiseUtils.makeCancelable(modelPromise, resolved => resolved.close());
    this.modelPromise.then(this.handleLoadSuccess).catch(this.handleLoadError);
  }
  handleLoadSuccess(modelParam) {
    var model = modelParam;
    var _this$state2 = this.state,
      panelState = _this$state2.panelState,
      irisGridStateOverrides = _this$state2.irisGridStateOverrides;
    var modelQueue = [];
    this.irisGridUtils = new IrisGridUtils(model.dh);
    if (panelState != null) {
      var irisGridState = panelState.irisGridState;
      var _irisGridState$irisGr = _objectSpread(_objectSpread({}, irisGridState), irisGridStateOverrides),
        aggregationSettings = _irisGridState$irisGr.aggregationSettings,
        customColumns = _irisGridState$irisGr.customColumns,
        _irisGridState$irisGr2 = _irisGridState$irisGr.selectDistinctColumns,
        selectDistinctColumns = _irisGridState$irisGr2 === void 0 ? [] : _irisGridState$irisGr2,
        rollupConfig = _irisGridState$irisGr.rollupConfig;
      if (customColumns.length > 0) {
        modelQueue.push(m => {
          // eslint-disable-next-line no-param-reassign
          m.customColumns = customColumns;
        });
      }
      if (rollupConfig != null && rollupConfig.columns.length > 0) {
        // originalColumns might change by the time this model queue item is applied.
        // Instead of pushing a static object, push the function
        // that calculates the config based on the updated model state.
        modelQueue.push(m => {
          // eslint-disable-next-line no-param-reassign
          m.rollupConfig = IrisGridUtils.getModelRollupConfig(m.originalColumns, rollupConfig, aggregationSettings);
        });
      }
      if (selectDistinctColumns.length > 0) {
        modelQueue.push(m => {
          // eslint-disable-next-line no-param-reassign
          m.selectDistinctColumns = selectDistinctColumns;
        });
      }
    }
    this.setState({
      model,
      modelQueue
    });
    this.initModelQueue(model, modelQueue);
  }
  initModelQueue(modelParam, modelQueue) {
    var model = modelParam;
    if (modelQueue.length === 0) {
      this.modelInitialized(model);
      return;
    }
    var modelChange = modelQueue.shift();
    log.debug('initModelQueue', modelChange);
    // Apply next model change. Triggers columnschanged event.
    if (modelChange) {
      modelChange(model);
    }
    this.setState({
      modelQueue
    });
  }
  handleAdvancedSettingsChange(key, value) {
    log.debug('handleAdvancedSettingsChange', key, value);
    this.setState(_ref3 => {
      var advancedSettings = _ref3.advancedSettings;
      return advancedSettings.get(key) === value ? null : {
        advancedSettings: new Map(advancedSettings).set(key, value)
      };
    });
  }
  handlePluginFilter(filters) {
    var _this$irisGridUtils$g, _this$irisGridUtils;
    var model = this.state.model;
    assertNotNull(model);
    var columns = model.columns,
      formatter = model.formatter;
    var pluginFilters = (_this$irisGridUtils$g = (_this$irisGridUtils = this.irisGridUtils) === null || _this$irisGridUtils === void 0 ? void 0 : _this$irisGridUtils.getFiltersFromInputFilters(columns, filters, formatter.timeZone)) !== null && _this$irisGridUtils$g !== void 0 ? _this$irisGridUtils$g : [];
    this.setState({
      pluginFilters
    });
  }
  handlePluginFetchColumns(pluginFetchColumns) {
    this.setState({
      pluginFetchColumns
    });
  }
  handleContextMenu(data) {
    var _this$pluginRef$curre, _this$pluginRef$curre2, _this$pluginRef$curre3;
    return (_this$pluginRef$curre = (_this$pluginRef$curre2 = this.pluginRef.current) === null || _this$pluginRef$curre2 === void 0 || (_this$pluginRef$curre3 = _this$pluginRef$curre2.getMenu) === null || _this$pluginRef$curre3 === void 0 ? void 0 : _this$pluginRef$curre3.call(_this$pluginRef$curre2, data)) !== null && _this$pluginRef$curre !== void 0 ? _this$pluginRef$curre : [];
  }
  isColumnSelectionValid(tableColumn) {
    var columnSelectionValidator = this.props.columnSelectionValidator;
    if (columnSelectionValidator && tableColumn) {
      return columnSelectionValidator(this, tableColumn, {
        type: 'tableLink'
      });
    }
    return false;
  }
  handleGridStateChange(irisGridState, gridState) {
    this.irisGridState = irisGridState;
    this.gridState = gridState;

    // Grid sends it's first state change after it's finished loading
    this.setState({
      isLoaded: true,
      isLoading: false
    });
    this.savePanelState();
    var _this$props2 = this.props,
      glEventHub = _this$props2.glEventHub,
      onStateChange = _this$props2.onStateChange;
    glEventHub.emit(IrisGridEvent.STATE_CHANGED, this);
    onStateChange === null || onStateChange === void 0 || onStateChange(irisGridState, gridState);
  }
  handlePluginStateChange(pluginState) {
    var irisGridState = this.irisGridState,
      gridState = this.gridState;
    this.pluginState = pluginState;
    // Do not save if there is null state
    // The save will happen when the grid loads
    if (irisGridState !== null && gridState !== null) {
      this.savePanelState();
    }
  }
  handleColumnsChanged(event) {
    var _this$state3 = this.state,
      isModelReady = _this$state3.isModelReady,
      model = _this$state3.model,
      modelQueue = _this$state3.modelQueue;
    if (isModelReady) {
      this.sendColumnsChange(event.detail);
    } else {
      assertNotNull(model);
      this.initModelQueue(model, modelQueue);
    }
  }
  handleTableChanged(event) {
    log.debug('handleTableChanged', event);
    var glEventHub = this.props.glEventHub;
    var _ref4 = event,
      table = _ref4.detail;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitFilterTableChanged(glEventHub, panelId, table);
  }

  /**
   * Create a chart with the specified settings
   * @param settings The settings from the chart builder
   * @param settings.type The settings from the chart builder
   * @param settings.series The names of the series
   * @param model The IrisGridModel object
   */
  handleCreateChart(settings, model) {
    // Panel state is stored with the created chart, so flush it first
    this.savePanelState.flush();
    this.setState(() => null, () => {
      var _this$props3 = this.props,
        glEventHub = _this$props3.glEventHub,
        inputFilters = _this$props3.inputFilters,
        metadata = _this$props3.metadata;
      var table = this.getTableName();
      var panelState = this.state.panelState;
      var sourcePanelId = LayoutUtils.getIdFromPanel(this);
      var tableSettings;
      if (panelState) {
        tableSettings = IrisGridUtils.extractTableSettings(panelState, inputFilters);
      }
      glEventHub.emit(IrisGridEvent.CREATE_CHART, {
        metadata: _objectSpread(_objectSpread({}, metadata), {}, {
          settings,
          sourcePanelId,
          table,
          tableSettings
        }),
        table: isIrisGridTableModelTemplate(model) ? model.table : undefined
      });
    });
  }
  handleColumnSelected(column) {
    var glEventHub = this.props.glEventHub;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitLinkPointSelected(glEventHub, panelId, column, {
      type: 'tableLink'
    });
  }
  handleDataSelected(row, dataMap) {
    var glEventHub = this.props.glEventHub;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitLinkSourceDataSelected(glEventHub, panelId, dataMap);
  }
  handleShow() {
    this.updateGrid();
  }
  handleTabClicked() {
    if (this.irisGrid.current) {
      this.irisGrid.current.focus();
    }
  }
  handleError(error) {
    log.error(error);
    this.setState({
      error,
      isLoading: false
    });
  }
  handleDisconnect() {
    this.setState({
      error: new Error('Table disconnected'),
      isDisconnected: true,
      isLoading: false
    });
  }
  handleReconnect() {
    this.setState({
      isDisconnected: false,
      error: null
    });
  }
  handleLoadError(error) {
    if (PromiseUtils.isCanceled(error)) {
      return;
    }
    this.handleError(error);
  }
  modelInitialized(model) {
    var _this$props4 = this.props,
      glEventHub = _this$props4.glEventHub,
      loadPlugin = _this$props4.loadPlugin,
      onModelChanged = _this$props4.onModelChanged;
    this.modelPromise = undefined;

    // Custom columns at this point already initialized, can load state
    this.loadPanelState(model);
    this.setState({
      isModelReady: true
    });
    onModelChanged === null || onModelChanged === void 0 || onModelChanged(model);
    if (isIrisGridTableModelTemplate(model)) {
      var table = model.table;
      var pluginName = table.pluginName;
      if (pluginName !== '') {
        if (loadPlugin != null && pluginName != null) {
          var Plugin = loadPlugin(pluginName);
          this.setState({
            Plugin
          });
        }
      }
      var panelId = LayoutUtils.getIdFromPanel(this);
      assertNotNull(panelId);
      emitFilterTableChanged(glEventHub, panelId, table);
    }
    this.sendColumnsChange(model.columns);
  }
  handleClearAllFilters() {
    var irisGrid = this.irisGrid.current;
    var isDisconnected = this.state.isDisconnected;
    if (irisGrid != null && !isDisconnected) {
      irisGrid.clearAllFilters();
    }
  }

  /**
   * Called when a user clicks the "Reset" button for an error message on the LoadingOverlay.
   */
  handleErrorAction() {
    if (this.irisGrid.current != null) {
      this.irisGrid.current.rollback();
      this.setState({
        error: null,
        isLoading: false
      });
    }
  }
  sendColumnsChange(columns) {
    log.debug2('sendColumnsChange', columns);
    var glEventHub = this.props.glEventHub;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitFilterColumnsChanged(glEventHub, panelId, columns);
  }
  startModelListening(model) {
    model.addEventListener(IrisGridModel.EVENT.DISCONNECT, this.handleDisconnect);
    model.addEventListener(IrisGridModel.EVENT.RECONNECT, this.handleReconnect);
    model.addEventListener(IrisGridModel.EVENT.COLUMNS_CHANGED, this.handleColumnsChanged);
    model.addEventListener(IrisGridModel.EVENT.TABLE_CHANGED, this.handleTableChanged);
  }
  stopModelListening(model) {
    model.removeEventListener(IrisGridModel.EVENT.DISCONNECT, this.handleDisconnect);
    model.removeEventListener(IrisGridModel.EVENT.RECONNECT, this.handleReconnect);
    model.removeEventListener(IrisGridModel.EVENT.COLUMNS_CHANGED, this.handleColumnsChanged);
    model.removeEventListener(IrisGridModel.EVENT.TABLE_CHANGED, this.handleTableChanged);
  }
  getCoordinateForColumn(columnName) {
    var _gridWrapper$getBound, _allColumnXs$get, _allColumnWidths$get;
    var model = this.state.model;
    if (!model) {
      return null;
    }
    var irisGrid = this.irisGrid.current;
    var _ref5 = irisGrid || {},
      gridWrapper = _ref5.gridWrapper;
    var rect = (_gridWrapper$getBound = gridWrapper === null || gridWrapper === void 0 ? void 0 : gridWrapper.getBoundingClientRect()) !== null && _gridWrapper$getBound !== void 0 ? _gridWrapper$getBound : null;
    if (rect == null || rect.width <= 0 || rect.height <= 0) {
      return null;
    }
    assertNotNull(irisGrid);
    var metrics = irisGrid.state.metrics;
    assertNotNull(metrics);
    var columnHeaderHeight = metrics.columnHeaderHeight,
      allColumnXs = metrics.allColumnXs,
      allColumnWidths = metrics.allColumnWidths,
      right = metrics.right,
      columnHeaderMaxDepth = metrics.columnHeaderMaxDepth;
    var columnIndex = model.getColumnIndexByName(columnName);
    assertNotNull(columnIndex);
    var visibleIndex = irisGrid.getVisibleColumn(columnIndex);
    var columnX = (_allColumnXs$get = allColumnXs.get(visibleIndex)) !== null && _allColumnXs$get !== void 0 ? _allColumnXs$get : 0;
    var columnWidth = (_allColumnWidths$get = allColumnWidths.get(visibleIndex)) !== null && _allColumnWidths$get !== void 0 ? _allColumnWidths$get : 0;
    var x = clamp(visibleIndex > right ? rect.right : rect.left + columnX + columnWidth * 0.5, rect.left, rect.right);
    var y = rect.top + columnHeaderHeight * columnHeaderMaxDepth;
    return [x, y];
  }
  setFilterMap(filterMap) {
    var irisGrid = this.irisGrid.current;
    if (irisGrid != null) {
      irisGrid.setFilterMap(filterMap);
    }
  }
  setAdvancedFilterMap(filterMap) {
    var irisGrid = this.irisGrid.current;
    if (irisGrid != null) {
      irisGrid.setAdvancedFilterMap(filterMap);
    }
  }
  setFilters(_ref6) {
    var quickFilters = _ref6.quickFilters,
      advancedFilters = _ref6.advancedFilters;
    log.debug('setFilters', quickFilters, advancedFilters);
    var _this$state4 = this.state,
      model = _this$state4.model,
      isDisconnected = _this$state4.isDisconnected;
    var irisGrid = this.irisGrid.current;
    if (irisGrid == null || isDisconnected) {
      log.debug('Ignore setFilters, model disconnected');
      return;
    }
    assertNotNull(model);
    var columns = model.columns,
      formatter = model.formatter;
    var indexedQuickFilters = IrisGridUtils.changeFilterColumnNamesToIndexes(model.columns, quickFilters).filter(_ref7 => {
      var _ref8 = _slicedToArray(_ref7, 1),
        columnIndex = _ref8[0];
      return model.isFilterable(columnIndex);
    });
    var indexedAdvancedFilters = IrisGridUtils.changeFilterColumnNamesToIndexes(model.columns, advancedFilters).filter(_ref9 => {
      var _ref0 = _slicedToArray(_ref9, 1),
        columnIndex = _ref0[0];
      return model.isFilterable(columnIndex);
    });
    assertNotNull(this.irisGridUtils);
    irisGrid.clearAllFilters();
    irisGrid.setFilters({
      quickFilters: this.irisGridUtils.hydrateQuickFilters(columns, indexedQuickFilters, formatter.timeZone),
      advancedFilters: this.irisGridUtils.hydrateAdvancedFilters(columns, indexedAdvancedFilters, formatter.timeZone)
    });
  }
  setStateOverrides(overrides) {
    log.debug('setStateOverrides', overrides);
    var irisGridStateOverrides = overrides.irisGridState,
      gridStateOverrides = overrides.gridState;
    this.setState({
      irisGridStateOverrides,
      gridStateOverrides
    }, () => {
      this.initModel();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  unsetFilterValue() {
    // IrisGridPanel retains the set value after the link is broken
    // We need to define this so LinkerUtils#isLinkablePanel passes the check
  }
  loadPanelState(model) {
    var _this$state5 = this.state,
      panelState = _this$state5.panelState,
      originalIrisGridStateOverrides = _this$state5.irisGridStateOverrides,
      gridStateOverrides = _this$state5.gridStateOverrides;
    if (panelState == null) {
      return;
    }
    try {
      var gridState = panelState.gridState,
        irisGridState = panelState.irisGridState,
        irisGridPanelState = panelState.irisGridPanelState;
      var irisGridStateOverrides = _objectSpread({}, originalIrisGridStateOverrides);
      var savedQuickFilters = irisGridStateOverrides.quickFilters,
        savedAdvancedFilters = irisGridStateOverrides.advancedFilters;
      if (savedQuickFilters) {
        irisGridStateOverrides.quickFilters = IrisGridUtils.changeFilterColumnNamesToIndexes(model.columns, savedQuickFilters);
      }
      if (savedAdvancedFilters) {
        irisGridStateOverrides.advancedFilters = IrisGridUtils.changeFilterColumnNamesToIndexes(model.columns, savedAdvancedFilters);
      }
      var _IrisGridUtils$hydrat = IrisGridUtils.hydrateIrisGridPanelState(model, irisGridPanelState),
        isSelectingPartition = _IrisGridUtils$hydrat.isSelectingPartition,
        partitions = _IrisGridUtils$hydrat.partitions,
        advancedSettings = _IrisGridUtils$hydrat.advancedSettings;
      assertNotNull(this.irisGridUtils);
      var _this$irisGridUtils$h = this.irisGridUtils.hydrateIrisGridState(model, _objectSpread(_objectSpread({}, irisGridState), irisGridStateOverrides)),
        advancedFilters = _this$irisGridUtils$h.advancedFilters,
        customColumns = _this$irisGridUtils$h.customColumns,
        customColumnFormatMap = _this$irisGridUtils$h.customColumnFormatMap,
        columnAlignmentMap = _this$irisGridUtils$h.columnAlignmentMap,
        isFilterBarShown = _this$irisGridUtils$h.isFilterBarShown,
        quickFilters = _this$irisGridUtils$h.quickFilters,
        reverse = _this$irisGridUtils$h.reverse,
        rollupConfig = _this$irisGridUtils$h.rollupConfig,
        aggregationSettings = _this$irisGridUtils$h.aggregationSettings,
        sorts = _this$irisGridUtils$h.sorts,
        userColumnWidths = _this$irisGridUtils$h.userColumnWidths,
        userColumnWidthsByName = _this$irisGridUtils$h.userColumnWidthsByName,
        userRowHeights = _this$irisGridUtils$h.userRowHeights,
        showSearchBar = _this$irisGridUtils$h.showSearchBar,
        searchValue = _this$irisGridUtils$h.searchValue,
        selectDistinctColumns = _this$irisGridUtils$h.selectDistinctColumns,
        selectedSearchColumns = _this$irisGridUtils$h.selectedSearchColumns,
        invertSearchColumns = _this$irisGridUtils$h.invertSearchColumns,
        pendingDataMap = _this$irisGridUtils$h.pendingDataMap,
        frozenColumns = _this$irisGridUtils$h.frozenColumns,
        conditionalFormats = _this$irisGridUtils$h.conditionalFormats,
        columnHeaderGroups = _this$irisGridUtils$h.columnHeaderGroups,
        partitionConfig = _this$irisGridUtils$h.partitionConfig;
      var _IrisGridUtils$hydrat2 = IrisGridUtils.hydrateGridState(model, _objectSpread(_objectSpread({}, gridState), gridStateOverrides), irisGridState.customColumns),
        isStuckToBottom = _IrisGridUtils$hydrat2.isStuckToBottom,
        isStuckToRight = _IrisGridUtils$hydrat2.isStuckToRight,
        movedColumns = _IrisGridUtils$hydrat2.movedColumns,
        movedRows = _IrisGridUtils$hydrat2.movedRows;
      this.setState({
        advancedFilters,
        advancedSettings,
        conditionalFormats,
        customColumns,
        customColumnFormatMap,
        columnAlignmentMap,
        isFilterBarShown,
        isSelectingPartition,
        movedColumns,
        movedRows,
        partitions,
        quickFilters,
        reverse,
        rollupConfig,
        aggregationSettings,
        sorts,
        userColumnWidths,
        userColumnWidthsByName,
        userRowHeights,
        showSearchBar,
        searchValue,
        selectDistinctColumns,
        selectedSearchColumns,
        invertSearchColumns,
        pendingDataMap,
        frozenColumns,
        isStuckToBottom,
        isStuckToRight,
        columnHeaderGroups,
        partitionConfig
      });
    } catch (error) {
      log.error('loadPanelState failed to load panelState', panelState, error);
    }
  }
  updateGrid() {
    var _this$irisGrid$curren2, _this$irisGrid$curren3;
    var grid = (_this$irisGrid$curren2 = (_this$irisGrid$curren3 = this.irisGrid.current) === null || _this$irisGrid$curren3 === void 0 ? void 0 : _this$irisGrid$curren3.grid) !== null && _this$irisGrid$curren2 !== void 0 ? _this$irisGrid$curren2 : null;
    if (!grid) return;

    // handle resize will verify state and draw and update
    grid.handleResize();
  }
  render() {
    var _model$description, _panelState$pluginSta;
    var _this$props5 = this.props,
      children = _this$props5.children,
      glContainer = _this$props5.glContainer,
      glEventHub = _this$props5.glEventHub,
      columnSelectionValidator = _this$props5.columnSelectionValidator,
      getDownloadWorker = _this$props5.getDownloadWorker,
      inputFilters = _this$props5.inputFilters,
      links = _this$props5.links,
      metadata = _this$props5.metadata,
      panelState = _this$props5.panelState,
      user = _this$props5.user,
      settings = _this$props5.settings,
      irisGridProps = _this$props5.irisGridProps,
      transformTableOptions = _this$props5.transformTableOptions;
    var _this$state6 = this.state,
      advancedFilters = _this$state6.advancedFilters,
      aggregationSettings = _this$state6.aggregationSettings,
      advancedSettings = _this$state6.advancedSettings,
      conditionalFormats = _this$state6.conditionalFormats,
      customColumns = _this$state6.customColumns,
      customColumnFormatMap = _this$state6.customColumnFormatMap,
      columnAlignmentMap = _this$state6.columnAlignmentMap,
      error = _this$state6.error,
      isDisconnected = _this$state6.isDisconnected,
      isFilterBarShown = _this$state6.isFilterBarShown,
      isSelectingPartition = _this$state6.isSelectingPartition,
      isStuckToBottom = _this$state6.isStuckToBottom,
      isStuckToRight = _this$state6.isStuckToRight,
      isLoaded = _this$state6.isLoaded,
      isLoading = _this$state6.isLoading,
      isModelReady = _this$state6.isModelReady,
      model = _this$state6.model,
      movedColumns = _this$state6.movedColumns,
      movedRows = _this$state6.movedRows,
      partitions = _this$state6.partitions,
      partitionConfig = _this$state6.partitionConfig,
      quickFilters = _this$state6.quickFilters,
      reverse = _this$state6.reverse,
      rollupConfig = _this$state6.rollupConfig,
      sorts = _this$state6.sorts,
      userColumnWidths = _this$state6.userColumnWidths,
      userColumnWidthsByName = _this$state6.userColumnWidthsByName,
      userRowHeights = _this$state6.userRowHeights,
      showSearchBar = _this$state6.showSearchBar,
      searchValue = _this$state6.searchValue,
      selectDistinctColumns = _this$state6.selectDistinctColumns,
      selectedSearchColumns = _this$state6.selectedSearchColumns,
      invertSearchColumns = _this$state6.invertSearchColumns,
      Plugin = _this$state6.Plugin,
      pluginFilters = _this$state6.pluginFilters,
      pluginFetchColumns = _this$state6.pluginFetchColumns,
      pendingDataMap = _this$state6.pendingDataMap,
      frozenColumns = _this$state6.frozenColumns,
      columnHeaderGroups = _this$state6.columnHeaderGroups;
    var errorMessage = error != null ? "Unable to open table. ".concat(error) : undefined;
    var description = (_model$description = model === null || model === void 0 ? void 0 : model.description) !== null && _model$description !== void 0 ? _model$description : undefined;
    var pluginState = (_panelState$pluginSta = panelState === null || panelState === void 0 ? void 0 : panelState.pluginState) !== null && _panelState$pluginSta !== void 0 ? _panelState$pluginSta : null;
    var childrenContent = children !== null && children !== void 0 ? children : this.getPluginContent(Plugin, model, pluginState);
    var permissions = user.permissions;
    var canCopy = permissions.canCopy,
      canDownloadCsv = permissions.canDownloadCsv;
    var widgetPanelDescriptor = this.getWidgetPanelDescriptor(metadata, description);
    return /*#__PURE__*/_jsx(WidgetPanel, {
      errorMessage: errorMessage,
      isDisconnected: isDisconnected,
      isLoading: isLoading,
      isLoaded: isLoaded,
      onErrorAction: this.irisGrid.current != null ? this.handleErrorAction : undefined,
      className: "iris-grid-panel",
      glContainer: glContainer,
      glEventHub: glEventHub,
      onClearAllFilters: this.handleClearAllFilters,
      onShow: this.handleShow,
      onTabFocus: this.handleShow,
      onTabClicked: this.handleTabClicked,
      componentPanel: this,
      descriptor: widgetPanelDescriptor,
      renderTabTooltip: () => /*#__PURE__*/_jsx(IrisGridPanelTooltip, {
        descriptor: widgetPanelDescriptor,
        model: model
      }),
      children: isModelReady && model && /*#__PURE__*/_jsx(IrisGrid, _objectSpread(_objectSpread({
        advancedFilters: advancedFilters,
        aggregationSettings: aggregationSettings,
        advancedSettings: advancedSettings,
        alwaysFetchColumns: this.getAlwaysFetchColumns(links, pluginFetchColumns),
        columnAllowedCursor: "linker",
        columnNotAllowedCursor: "linker-not-allowed",
        copyCursor: "copy",
        customColumns: customColumns,
        customColumnFormatMap: customColumnFormatMap,
        columnAlignmentMap: columnAlignmentMap,
        columnSelectionValidator: this.isColumnSelectionValid,
        conditionalFormats: conditionalFormats,
        inputFilters: this.getGridInputFilters(model.columns, inputFilters),
        applyInputFiltersOnInit: panelState == null,
        isFilterBarShown: isFilterBarShown,
        isSelectingColumn: columnSelectionValidator != null,
        isSelectingPartition: isSelectingPartition,
        isStuckToBottom: isStuckToBottom,
        isStuckToRight: isStuckToRight,
        movedColumns: movedColumns,
        movedRows: movedRows,
        partitions: partitions,
        partitionConfig: partitionConfig,
        quickFilters: quickFilters,
        reverse: reverse,
        rollupConfig: rollupConfig,
        settings: settings,
        sorts: sorts,
        userColumnWidths: userColumnWidths,
        userColumnWidthsByName: userColumnWidthsByName,
        userRowHeights: userRowHeights,
        model: model,
        showSearchBar: showSearchBar,
        searchValue: searchValue,
        selectedSearchColumns: selectedSearchColumns,
        selectDistinctColumns: selectDistinctColumns,
        invertSearchColumns: invertSearchColumns,
        onColumnSelected: this.handleColumnSelected,
        onCreateChart: this.handleCreateChart,
        onDataSelected: this.handleDataSelected,
        onError: this.handleError,
        onStateChange: this.handleGridStateChange,
        onContextMenu: this.handleContextMenu,
        onAdvancedSettingsChange: this.handleAdvancedSettingsChange,
        customFilters: pluginFilters,
        pendingDataMap: pendingDataMap,
        canCopy: canCopy,
        canDownloadCsv: canDownloadCsv,
        ref: this.irisGrid,
        getDownloadWorker: getDownloadWorker,
        frozenColumns: frozenColumns,
        columnHeaderGroups: columnHeaderGroups,
        transformTableOptions: transformTableOptions
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, irisGridProps), {}, {
        children: childrenContent
      }))
    });
  }
}
_defineProperty(IrisGridPanel, "defaultProps", {
  onStateChange: () => undefined,
  onPanelStateUpdate: () => undefined
});
_defineProperty(IrisGridPanel, "displayName", 'IrisGridPanel');
_defineProperty(IrisGridPanel, "COMPONENT", 'IrisGridPanel');
var mapStateToProps = (state, _ref1) => {
  var _ref1$localDashboardI = _ref1.localDashboardId,
    localDashboardId = _ref1$localDashboardI === void 0 ? DEFAULT_DASHBOARD_ID : _ref1$localDashboardI,
    glContainer = _ref1.glContainer;
  return {
    inputFilters: getInputFiltersForDashboard(state, localDashboardId),
    links: getLinksForDashboard(state, localDashboardId),
    columnSelectionValidator: getColumnSelectionValidatorForDashboard(state, localDashboardId),
    user: getUser(state),
    settings: getSettings(state)
  };
};
var ConnectedIrisGridPanel = connect(mapStateToProps, null, null, {
  forwardRef: true
})(IrisGridPanel);
export default ConnectedIrisGridPanel;
//# sourceMappingURL=IrisGridPanel.js.map